<template>
  <a-modal
    :visible="visible"
    :footer="null"
    :header="null"
    @cancel="closeModal"
    wrapClassName="report-modal"
  >
    <div class="report">
      <h2 class="report__title">Report</h2>
      <!-- <h4 class="report__sub-title">
        {{ title }}
      </h4>
      <p class="report__dec">
        {{ reportDescription  }}
      </p> -->
      <p v-if="unselectRadio" class="error">Please select any one of them.</p>
      <a-radio-group name="radioGroup" v-model:value="value">
        <a-radio value="advertisement">Seems like an advertisement</a-radio>
        <a-radio value="nudity" >Seems like nudity</a-radio>
        <a-radio value="inciting voilence" >Seems like inciting violence</a-radio>
        <a-radio value="terrorism" >Seems like terrorism</a-radio>
        <a-radio value="spam" >Seems like a spam</a-radio>
        <a-radio value="bullying/harassment" >Seems like bullying and/or harassment</a-radio>
        <a-radio value="other" >Other</a-radio>
      </a-radio-group>
      <transition name="text-content" mode="out-in">
        <div v-if="value == 'other'">
          <h4 class="report__sub-title">Reason</h4>
          <p class="report__dec">Please write a reason here.</p>
          <textarea v-model="detail" rows="4" placeholder="Write a message" ></textarea>
          <p v-if="error" class="error">This field is required.</p>
        </div>
      </transition>
      <p class="report__warning-message">Warning: Article will be removed from the topic if reported.*</p>
      <a-button :loading="loader" class="report__btn" @click="SubmitReport">Submit report</a-button>
    </div>
  </a-modal>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  emits: ["handle-close"],
  props: {
    visible: Boolean,
    title: String,
    reportDescription: String,
    reportedDocumentId: String,
    module:{
      type:String,
      default: () => ('articleCard')
    },
    reportType:{
      type: String,
      default: () => ('article')
    }
  },
  data() {
    return {
      value: "",
      detail: "",
      message: {},
      showMessageModal: false,
      loader: false,
      error: false,
      unselectRadio: false,
    };
  },
  watch:{
    detail:{
      handler(val){
        if (val && this.error){
          this.error = false
        }
      },immediate:true
    },
    value:{
      handler(val){
        if (val && this.unselectRadio){
          this.unselectRadio = false
        }
      },immediate:true
    }
  },
  methods: {
    ...mapActions({
      filterReportedDocumentFeed: 'feeds/filterReportedDocumentFeed',
      reportArticleOrFeed: 'discover/reportArticleOrFeed'
    }),
    closeModal() {
      this.$emit("handle-close", false);
      this.error = false
      this.loader = false
      this.value = ''
      this.detail = ''
      this.unselectRadio = false
    },
    async SubmitReport() {
      this.error = false;
      if(this.value == ""){
        this.unselectRadio = true;
        return false;
      }
      if(this.value == "other" && this.detail == ""){
        this.unselectRadio = false;
        this.error = true;
        return false;
      }
      this.loader = true;
      try{
        const payload = {
          type: this.reportType,
          reason: this.value,
          description: this.detail
        }
          await this.reportArticleOrFeed({reportDetailsPayload:payload, articleOrFeedId:this.reportedDocumentId})
          this.loader = false;
          this.closeModal();
          this.detail = "";
          this.error = false;
          this.unselectRadio = false;
          this.value=''
          this.$showToast({message:'Report submitted successfully', type:'success'})
      }catch (err){
          this.loader = false;
          this.closeModal();
          this.value=''
          this.detail = "";
          this.error = false;
          this.unselectRadio = false;
          this.$showToast({message:'Something went wrong. Please try again later.', type:'failure'})
      }
    },
  },
};
</script>

<style lang="scss">
.report-modal {
  .ant-modal {
    width: 50rem !important;
    top: 8rem;
    .ant-modal-content {
      padding: 3rem;
      background-color: rgb(246, 248, 255);
      .ant-modal-close {
        margin: 2.5rem 1.8rem 0 0;
      }
      .ant-modal-body {
        .report {
          &__title {
            font-size: 2.5rem;
            font-family: $font-primary-bold;
            margin-bottom: 2rem;
            line-height: normal;
          }
          &__sub-title {
            font-size: 2rem;
            font-family: $font-primary-medium;
            margin-bottom: 0.7rem;
            line-height: normal;
            color: $color-black;
          }
          &__dec {
            font-size: 1.6rem;
            font-family: $font-primary;
            margin-bottom: 2rem;
            line-height: normal;
            color: $color-black;
            opacity: 0.7;
          }
          &__warning-message {
            font-size: 1.6rem;
            font-family: $font-primary;
            margin-bottom: 2rem;
            line-height: normal;
            color: $color-warning;
            font-style: italic;
          }
          textarea {
            width: 100%;
            padding: 1rem;
            outline: none;
            border: 1px solid $color-dark-grey-5;
            resize: none;
            font-size: 1.6rem;
            font-family: $font-primary;
            line-height: 2.2rem;
            margin-bottom: 0.5rem;
            &::placeholder {
              color: $color-placeholder;
            }
          }
          &__btn {
            width: 100%;
            background-color: $color-primary;
            border: none;
            height: 4rem;
            font-size: 1.6rem;
            font-family: $font-primary-medium;
            color: $color-white;
            margin-top: 1rem;
            span {
              line-height: normal;
            }
          }
          .ant-radio-group {
            display: flex;
            flex-direction: column;
            margin-bottom: 2rem;
            .ant-radio-wrapper {
              font-size: 1.6rem;
              font-family: $font-primary;
              margin-bottom: 0.5rem;
              display: flex;
              align-items: center;
              .ant-radio {
                padding: 0;
                .ant-radio-inner {
                  border-color: gray;
                  width: 2rem;
                  height: 2rem;
                  padding: 0;
                }
              }
            }
            .ant-radio-wrapper > span {
              padding: 0 1rem;
            }
            .ant-radio-wrapper-checked {
              .ant-radio {
                .ant-radio-inner {
                  border-color: $color-primary;
                  position: initial;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  &::after {
                    position: initial;
                    width: 1rem;
                    height: 1rem;
                    background-color: $color-primary;
                    border-radius: 100% !important;
                  }
                }
              }
            }
          }
          .error {
            color: red;
            font-size: 1.6rem;
            font-family: $font-primary;
            margin-top: 0;
            margin-bottom: 1rem;
            line-height: normal;
            margin-top: -0.5rem;
          }
        }
      }
    }
    .text-content-enter-from,
    .text-content-leave-to {
      opacity: 0;
    }
    .text-content-enter-active {
      transition: opacity 0.5s ease-in-out;
    }
    .text-content-enter-to,
    .text-content-leave-from {
      opacity: 1;
    }
  }
}
</style>
